import i18next, { type InitOptions } from 'i18next'
import LanguageDetector, { type DetectorOptions } from 'i18next-browser-languagedetector'
// import FsBackend, { type FsBackendOptions } from 'i18next-fs-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import i18nextVue from 'i18next-vue'

import { isEnvironmentDevelopment } from '@/utilities/environments'
import { handleUnknownError } from '@/utilities/errors'

const i18nLanguageDetectorOptions: DetectorOptions = {
  // add options here
}
const i18nextBrowserLanguageDetector = new LanguageDetector()

i18nextBrowserLanguageDetector.init(i18nLanguageDetectorOptions)

// const i18nextInitializationOptions: InitOptions<FsBackendOptions> = {
const i18nextInitializationOptions: InitOptions = {
  // i18next options
  cleanCode: true,
  debug: isEnvironmentDevelopment,
  fallbackLng: ['de'],
  lng: 'de',
  // vue recommended this option ("Vue will already properly escape values intended as plain text")
  interpolation: {
    escapeValue: false,
  },
  saveMissing: true,
  supportedLngs: ['de', 'en'],

  defaultNS: ['app', 'translation'],
  fallbackNS: ['common', 'system', 'translation', 'backend'],
  ns: ['app', 'common', 'system', 'translation', 'backend'],

  // FsBackend options
  // backend: {
  //   addPath: './assets/locales/{{lng}}/{{ns}}.json',
  //   loadPath: './assets/locales/{{lng}}/{{ns}}.missing.json',
  // },
}

// for development the 'dev' "language" will be used for the missing translation key function
// if (isEnvironmentProduction) {
//   i18nextInitializationOptions.fallbackLng = ['de']
// }

const i18nextInstance = i18next

const i18nextInit = async (): Promise<boolean> => {
  let isI18nextReady = false

  await i18nextInstance
    // .use(FsBackend)
    .use(
      resourcesToBackend(async (language: string, namespace: string) => {
        return await import(`../assets/locales/${language}/${namespace}.json`)
      }),
    )
    .use(i18nextBrowserLanguageDetector)
    .init(i18nextInitializationOptions)
    .then(() => {
      isI18nextReady = true
    })
    .catch((i18nextError: unknown) => {
      if (i18nextError instanceof Error) {
        console.error(i18nextError.message)
      } else {
        handleUnknownError(i18nextError)
      }
      console.error('Error while i18next Initialization!')

      isI18nextReady = false
    })

  return isI18nextReady
}

const i18nextVuePlugin = i18nextVue

export { i18nextInit, i18nextInstance, i18nextVuePlugin }
